<div class="header">
  <div class="header-cont about-page">
    <h2>{{ 'about.title' | translate }}</h2>
    <h3>{{ 'about.subtitle' | translate }} 
      <a 
        class="primis-links" 
        href="https://2014-2020.ita-slo.eu/it/primis" 
        target="_blank" 
        rel="noopener noreferrer"
      >https://2014-2020.ita-slo.eu/it/primis</a>
    </h3>
    <img src="../../../assets/about/logo_primis.svg">
  </div>
</div>
<div class="header">
  <div class="header-cont about-page">
    <h2>{{ 'about.title_plus' | translate }}</h2>
    <h3>{{ 'about.subtitle_plus' | translate }} 
      <a 
        class="primis-links" 
        href="https://www.ita-slo.eu/it/primis-plus" 
        target="_blank" 
        rel="noopener noreferrer"
      >https://www.ita-slo.eu/it/primis-plus</a>
    </h3>
  </div>
</div>
<div class="single-section">
  <div class="section-cont">
    <div class="grey" [innerHTML]="'about.descr' | translate"></div>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <div class="cards">
      <div class="single-card">
        <mat-card class="zoom-in" [routerLink]="['/home/poi']">
          <mat-card-header class="about-card-header">
            <img src="../../../assets/about/pois.png" [title]="'about.cards.pois.title' | translate">
          </mat-card-header>
          <mat-card-content>
            <div class="card-text">
              <h4>{{ 'about.cards.pois.title' | translate }}</h4>
              <p class="grey">{{ 'about.cards.pois.descr' | translate }}</p>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="single-card">
        <mat-card class="zoom-in" [routerLink]="['/home/itinerari']">
          <mat-card-header class="about-card-header">
            <img src="../../../assets/about/itin.png" [title]="'about.cards.itin.title' | translate">
          </mat-card-header>
          <mat-card-content>
            <div class="card-text">
              <h4>{{ 'about.cards.itin.title' | translate }}</h4>
              <p class="grey">{{ 'about.cards.itin.descr' | translate }}</p>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'about.multimedia.title' | translate }}</h3>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <p class="grey">{{ 'about.multimedia.descr' | translate }}</p>
  </div>
</div>

<div class="single-section grey">
  <div class="section-cont">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.multimedia.single_center.first.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.multimedia.single_center.first.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/centro_multimediale_bibione.jpg">
      <p>{{ 'about.multimedia.single_center.first.descr' | translate }}</p>
      <i [innerHTML]="'about.multimedia.single_center.first.contacts' | translate"></i>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.multimedia.single_center.second.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.multimedia.single_center.second.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/centro_multimediale_capodistria.jpg">
      <p>{{ 'about.multimedia.single_center.second.descr' | translate }}</p>
      <i [innerHTML]="'about.multimedia.single_center.second.contacts' | translate"></i>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.multimedia.single_center.third.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.multimedia.single_center.third.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/centro_multimediale_santo_stefano.jpg">
      <p>{{ 'about.multimedia.single_center.third.descr' | translate }}</p>
      <i [innerHTML]="'about.multimedia.single_center.third.contacts' | translate"></i>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.multimedia.single_center.fourth.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.multimedia.single_center.fourth.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/centro_multimediale_trieste.jpg">
      <p>{{ 'about.multimedia.single_center.fourth.descr' | translate }}</p>
      <i [innerHTML]="'about.multimedia.single_center.fourth.contacts' | translate"></i>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.multimedia.single_center.fifth.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.multimedia.single_center.fifth.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/centro_multimediale_lubiana.jpg">
      <p>{{ 'about.multimedia.single_center.fifth.descr' | translate }}</p>
      <i [innerHTML]="'about.multimedia.single_center.fifth.contacts' | translate"></i>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.multimedia.single_center.sixth.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.multimedia.single_center.sixth.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/centro_multimediale_palazzo_mantica.jpg">
      <p>{{ 'about.multimedia.single_center.sixth.descr' | translate }}</p>
      <i [innerHTML]="'about.multimedia.single_center.sixth.contacts' | translate"></i>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.multimedia.single_center.seventh.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.multimedia.single_center.seventh.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/centro_multimediale_casa_ascoli.jpg">
      <p>{{ 'about.multimedia.single_center.seventh.descr' | translate }}</p>
      <i [innerHTML]="'about.multimedia.single_center.seventh.contacts' | translate"></i>
    </mat-expansion-panel>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'about.info.title' | translate }}</h3>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <p class="grey">{{ 'about.info.descr' | translate }}</p>
  </div>
</div>

<div class="single-section grey">
  <div class="section-cont">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.info.single_infopoint.first.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.info.single_infopoint.first.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/info_point.jpg">
      <p><i [innerHTML]="'about.info.single_infopoint.first.contacts' | translate"></i></p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.info.single_infopoint.second.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.info.single_infopoint.second.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/info_point_pivka.jpg">
      <p><i [innerHTML]="'about.info.single_infopoint.second.contacts' | translate"></i></p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'about.info.single_infopoint.third.name' | translate }}
        </mat-panel-title>
        <mat-panel-description class="city">
          {{ 'about.info.single_infopoint.third.city' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <img src="../../../assets/about/info_point_trieste.jpg">
      <p><i [innerHTML]="'about.info.single_infopoint.third.contacts' | translate"></i></p>
    </mat-expansion-panel>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'about.partner.primis.title' | translate }}</h3>
  </div>
</div>

<div class="single-section">
  <div class="section-cont partners">
    <div>

      <a href="https://unione-italiana.eu/index.php/it/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/UI_blu.png" [alt]="'about.partner.primis.ui' | translate"
            [title]="'about.partner.primis.ui' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/UI_s_blu.png" [alt]="'about.partner.primis.ui' | translate"
            [title]="'about.partner.primis.ui' | translate">
        </div>
      </a>
      <a href="http://www.regione.fvg.it/rafvg/cms/RAFVG/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/friuli.png" [alt]="'about.partner.primis.friuli' | translate"
            [title]="'about.partner.primis.friuli' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/friuli_s.png" [alt]="'about.partner.primis.friuli' | translate"
            [title]="'about.partner.primis.friuli' | translate">
        </div>
      </a>
      <a href="https://www.regione.veneto.it/web/guest/home" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/veneto.png" [alt]="'about.partner.primis.veneto' | translate"
            [title]="'about.partner.primis.veneto' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/veneto_s.png" [alt]="'about.partner.primis.veneto' | translate"
            [title]="'about.partner.primis.veneto' | translate">
        </div>
      </a>
      <a href="https://www.gov.si/drzavni-organi/vladne-sluzbe/sluzba-vlade-za-razvoj-in-evropsko-kohezijsko-politiko/"
        class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/tourism_slo.png" [alt]="'about.partner.primis.slo' | translate"
            [title]="'about.partner.primis.slo' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/tourism_slo_s.png" [alt]="'about.partner.primis.slo' | translate"
            [title]="'about.partner.primis.slo' | translate">
        </div>
      </a>
    </div>
  </div>
</div>

<div class="single-section">
  <div class="section-cont partners">
    <div>

      <a href="https://www.ita-slo.eu/it/primis" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/ATS_blu.png" [alt]="'about.partner.primis.ats' | translate"
            [title]="'about.partner.primis.ats' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/ATS_s_blu.png" [alt]="'about.partner.primis.ats' | translate"
            [title]="'about.partner.primis.ats' | translate">
        </div>
      </a>
      <a href="http://cancostiera.org/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/CAN.png" [alt]="'about.partner.primis.can' | translate"
            [title]="'about.partner.primis.can' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/CAN_s.png" [alt]="'about.partner.primis.can' | translate"
            [title]="'about.partner.primis.can' | translate">
        </div>
      </a>
      <a href="https://www.sdgz.it/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/SDGZ.png" [alt]="'about.partner.primis.sdgz' | translate"
            [title]="'about.partner.primis.sdgz' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/SDGZ_s.png" [alt]="'about.partner.primis.sdgz' | translate"
            [title]="'about.partner.primis.sdgz' | translate">
        </div>
      </a>
      <a href="https://www.rra-zk.si/en" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/RDA.png" [alt]="'about.partner.primis.rda' | translate"
            [title]="'about.partner.primis.rda' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/RDA_s.png" [alt]="'about.partner.primis.rda' | translate"
            [title]="'about.partner.primis.rda' | translate">
        </div>
      </a>
    </div>
  </div>
</div>

<div class="single-section">
  <div class="section-cont partners">
    <div>
      <a href="http://www.fondazionecst.info/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/comelico.png" [alt]="'about.partner.primis.comelico' | translate"
            [title]="'about.partner.primis.comelico' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/comelico_s.png" [alt]="'about.partner.primis.comelico' | translate"
            [title]="'about.partner.primis.comelico' | translate">
        </div>
      </a>
      <a href="https://www.vegal.net/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/vegal.png" [alt]="'about.partner.primis.vegal' | translate"
            [title]="'about.partner.primis.vegal' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/vegal_s.png" [alt]="'about.partner.primis.vegal' | translate"
            [title]="'about.partner.primis.vegal' | translate">
        </div>
      </a>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'about.partner.primis_plus.title' | translate }}</h3>
  </div>
</div>

<div class="single-section">
  <div class="section-cont partners">
    <div>

      <a href="https://unione-italiana.eu/index.php/it/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/UI_blu.png" [alt]="'about.partner.primis_plus.ui' | translate"
            [title]="'about.partner.primis_plus.ui' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/UI_s_blu.png" [alt]="'about.partner.primis_plus.ui' | translate"
            [title]="'about.partner.primis_plus.ui' | translate">
        </div>
      </a>
      <a href="http://www.regione.fvg.it/rafvg/cms/RAFVG/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/friuli.png" [alt]="'about.partner.primis_plus.friuli' | translate"
            [title]="'about.partner.primis_plus.friuli' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/friuli_s.png" [alt]="'about.partner.primis_plus.friuli' | translate"
            [title]="'about.partner.primis_plus.friuli' | translate">
        </div>
      </a>
      <a href="https://www.regione.veneto.it/web/guest/home" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/veneto.png" [alt]="'about.partner.primis_plus.veneto' | translate"
            [title]="'about.partner.primis_plus.veneto' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/veneto_s.png" [alt]="'about.partner.primis_plus.veneto' | translate"
            [title]="'about.partner.primis_plus.veneto' | translate">
        </div>
      </a>
      <a href="https://www.ita-slo.eu/it/primis-plus" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/ATS_blu.png" [alt]="'about.partner.primis_plus.ats' | translate"
            [title]="'about.partner.primis_plus.ats' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/ATS_s_blu.png" [alt]="'about.partner.primis_plus.ats' | translate"
            [title]="'about.partner.primis_plus.ats' | translate">
        </div>
      </a>
    </div>
  </div>
</div>

<div class="single-section">
  <div class="section-cont partners">
    <div>

      <a href="https://www.filologicafriulana.it/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/sff.png" [alt]="'about.partner.primis_plus.can' | translate"
            [title]="'about.partner.primis_plus.can' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/sff_s.png" [alt]="'about.partner.primis_plus.can' | translate"
            [title]="'about.partner.primis_plus.can' | translate">
        </div>
      </a>
      <a href="https://inv.si/predstavitev/" class="single-partner">
        <div class="img-container">
          <img src="../../../assets/about/inv.png" [alt]="'about.partner.primis_plus.can' | translate"
            [title]="'about.partner.primis_plus.can' | translate">
        </div>
        <div class="img-container-small">
          <img src="../../../assets/about/inv_s.png" [alt]="'about.partner.primis_plus.can' | translate"
            [title]="'about.partner.primis_plus.can' | translate">
        </div>
      </a>
    </div>
  </div>
</div>